// Archetype configurations for "Step Into Reality"
export const ARCHETYPES = {
  billionaire: {
    id: 'billionaire',
    name: 'Billionaire',
    emoji: '💎',
    tagline: 'Expansion · Certainty · Overflow',
    color: '#CA8A04',
    glowColor: 'rgba(202, 138, 4, 0.4)',
    bgGradient: 'from-amber-900/20 to-yellow-900/20',
    borderColor: 'border-amber-500/30',
    affirmations: [
      'I allow abundance to flow naturally',
      'I receive with ease',
      'I move from certainty',
      'Opportunities come to me',
      'Expansion feels normal',
      'I am worthy of overflow'
    ],
    immersionScript: {
      breath: `Take a slow breath in…
expanding through the chest…

and gently release

Again…
full, effortless inhale…

and soften

Nothing to force here
Just space`,
      identity: `There is a version of you…
where nothing feels out of reach

Where decisions are not heavy…
they are clear

Where money… opportunity… support…
moves naturally

Not because you chase it

…but because you allow it

This version of you…
does not question worth

It feels normal to receive`,
      embodiment: `Feel that now

In the chest
In the posture

A quiet certainty

No rush
No grasping

Just openness

Just knowing`,
      activation: `Step into it now

Move as this version

Decide as this version

What feels obvious here?

Let that land`,
      anchor: `Now anchor this

Lock it in

This is yours`
    }
  },
  rockstar: {
    id: 'rockstar',
    name: 'Rockstar',
    emoji: '🎤',
    tagline: 'Expression · Presence · Magnetism',
    color: '#DB2777',
    glowColor: 'rgba(219, 39, 119, 0.4)',
    bgGradient: 'from-pink-900/20 to-rose-900/20',
    borderColor: 'border-pink-500/30',
    affirmations: [
      'I express myself freely',
      'My presence is magnetic',
      'I am fully seen and at ease',
      'Energy flows through me',
      'I enjoy being me',
      'I shine without effort'
    ],
    immersionScript: {
      breath: `Breathe in…
with energy

and release

Again…
inhale…

and let it flow out

Let the body wake up`,
      identity: `There is a version of you…
that is fully expressed

Not holding back
Not filtering

Seen…
and completely at ease being seen

Energy moves through you freely

Your presence is felt

Not forced

Just natural`,
      embodiment: `Feel that in your body

A lightness
A flow

A magnetic pull

You don't try to be noticed

You simply are`,
      activation: `Step forward as this version

Speak as this version

Move as this version

Let it be effortless`,
      anchor: `Anchor this now

Feel it lock in

This is available to you`
    }
  },
  champion: {
    id: 'champion',
    name: 'Champion',
    emoji: '🏆',
    tagline: 'Precision · Focus · Execution',
    color: '#3B82F6',
    glowColor: 'rgba(59, 130, 246, 0.4)',
    bgGradient: 'from-blue-900/20 to-indigo-900/20',
    borderColor: 'border-blue-500/30',
    affirmations: [
      'I execute with precision',
      'I trust my training',
      'I remain calm under pressure',
      'I focus on what matters',
      'I perform at my best',
      'I am ready for this moment'
    ],
    immersionScript: {
      breath: `Slow inhale

controlled

steady

and release

Again

precision in the breath

calm in the body`,
      identity: `There is a version of you…
that executes with clarity

No hesitation
No noise

Just focus

Just presence

This version trusts itself

Not emotionally…

…but through knowing`,
      embodiment: `Feel the body stabilise

Grounded

Centred

Ready

Everything unnecessary drops away`,
      activation: `Step into it now

See clearly

Act cleanly

Trust the moment`,
      anchor: `Anchor this

Lock it into the body

This is your standard`
    }
  }
};

export const INTRO_SCRIPT = `Take a breath…

This is not about becoming someone new

And it is not about pretending

Everything you experience in life…
is shaped by the state you hold

The way you think
The way you move
The way you respond

Different versions of you…
already exist

Not in the future

But as possibilities within you now

This space allows you…
to tune into one of those versions

To feel it
To embody it

And to anchor it into your body

So that when life calls…

You don't try to rise to the moment

You simply return…
to who you already are

Take your time

Choose your reality`;

export const IMMERSION_PHASES = ['breath', 'identity', 'embodiment', 'activation', 'anchor'];

export const PHASE_LABELS = {
  breath: 'Breath',
  identity: 'Identity',
  embodiment: 'Embodiment',
  activation: 'Activation',
  anchor: 'Anchor'
};

export const DURATION_OPTIONS = [
  { value: 60, label: '1 min' },
  { value: 180, label: '3 min' },
  { value: 300, label: '5 min' }
];
